/* This function checks if the Client has access to network */
var LOG_MODULE_NAME = "[Aigo_Check_Connection]";
var ConnectionService = /** @class */ (function () {
    function ConnectionService() {
    }
    ConnectionService.networkStatus = function () {
        var status = navigator.onLine;
        console.log("".concat(LOG_MODULE_NAME, " Connection to network:  ").concat(status));
        return status;
    };
    return ConnectionService;
}());
export { ConnectionService };
